import { BatteryBluetoothIcon } from './BatteryBluetoothIcon';

/**
 * author: GreenTurtwig
 * id 3DB7EA89-8F0C-40DA-B45A-E5B588F2CC01
 * name battery-bluetooth
 * version: 2.4.85
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/battery-bluetooth.svg
 * tags
 * - Battery 
 */
export const BatteryBluetooth100Icon = BatteryBluetoothIcon;
export default BatteryBluetooth100Icon